import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Sidebar from 'components/modules/carrier/AdminSidebar';
import { onSaveCustomerDetails } from 'components/modules/user/customer-details';
import WebhooksList from 'components/modules/webhooks/List';
import PortProIntegration from 'components/modules/user/PortProIntegration';
import Spinner from 'components/ui/Spinner';
import { useTranslation } from 'react-i18next';
import CarrierEDISettings from './carrier-edi-settings';
const Loading = function () {
    return (React.createElement("div", { className: "justify-center lg:col-span-1", style: { top: '50%' } },
        React.createElement("div", { className: "align-middle" },
            React.createElement("span", { className: "text-5xl text-green" },
                React.createElement(Spinner, { showMessage: false })))));
};
const CarrierIntegrationSettings = () => {
    const { t } = useTranslation();
    const [carrier, setCarrier] = useState(null);
    const params = useParams();
    const carrierId = params.id;
    const renderSidebar = () => (React.createElement(Sidebar, { userId: carrierId, activePage: "integrations" }));
    const breadcrumbs = {
        pages: [
            {
                name: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || t('CARRIER'),
                href: `/users/${carrierId}`,
                current: false,
            },
            {
                name: 'Integrations',
                href: `/users/${carrierId}/carrier-settings/integrations`,
                current: true,
            },
        ],
    };
    const fetchUser = async () => {
        const user = await getCustomerV2(carrierId);
        setCarrier(user);
    };
    useEffect(() => {
        fetchUser();
    }, []);
    return (React.createElement(LayoutWithSidebar, { sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" }, carrier ? (React.createElement("div", { className: "lg:grid lg:grid-cols-2 lg:gap-4" },
        React.createElement(WebhooksList, { userId: carrier._id, accountType: carrier._type }),
        React.createElement(PortProIntegration, { carrierId: carrier._id }),
        React.createElement(CarrierEDISettings, { carrier: carrier, onCustomerPreferencesChange: onSaveCustomerDetails }))) : (React.createElement(Loading, null))));
};
export default CarrierIntegrationSettings;
